<template>
  <div class="itinerary-list">
      <div v-if="isListShown">
        <div class="header">
          <div class="heade-label t-title sm mb-m">Your <strong>Itinerary</strong></div>
        </div>
        <article v-for="date in solutionDates" :key="date.label">
          <div class="solution__day" v-if="dateExperiences[date.label].all.length">
            <div class="day__date">
              <h4 class="day__label">
                <strong>{{ date.label }}</strong> {{ date.description }}
              </h4>
            </div>
            <div class="day__activities">
              <ItineraryCard v-for="item in dateExperiences[date.label].all" :key="item.id" :activity="item">
                <div v-if="item.icon" class="icon">
                  <component :is="item.icon"></component>
                </div>
              </ItineraryCard>
            </div>
          </div>
        </article>
      </div>
      <div class="page-1" v-if="isSolutionLoaded" />
  </div>
</template>

<script>
import Vue from 'vue';
import VueCompositionAPI, {computed} from '@vue/composition-api';
import {useExpList} from '@components/explore-page/exp-list/exp-list';
import ItineraryCard from './itinerary-card';

import '@mobi-components/amex-poi-details-view/dist/amex-poi-details-view.css';
import {UserActivityCategoryEnum} from '@mobi-components/global-solution';
import { getAllRecommendationsContent, getRecommendationDetails } from '@/store/state/helpers';
import { getPoisFromRecommendations } from '@/store/state/main.module';

Vue.use(VueCompositionAPI);

export default {
  name: 'ItineraryList',
  components: {
    ItineraryCard,
  },
  props: {
    removedItems: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(_, {emit, root}) {
    const {solutionDates, ...expListProps} = useExpList(root, emit, [], true);
    const recommendations = computed(() => {
      return getPoisFromRecommendations(getRecommendationDetails());
    })
    const isListShown = computed(() => {
      if (expListProps.isSolutionLoading.value) {
        return false;
      }
      const res = !!(expListProps.solution.value?.activities || []).some((x) => {
        return x.category && x.category !== UserActivityCategoryEnum.CONTEXT && !x.spec?.curated;
      });

      return res;
    });
    const isSolutionLoaded = computed(() => {
      return !expListProps.isSolutionLoading.value && solutionDates.value.length && recommendations.value.length;
    });
    return {
      isSolutionLoaded,
      solutionDates,
      ...expListProps,
      isListShown,
    };
  },
};
</script>

<style scoped lang="scss">
@import '@components/solution-views/vue-transitions.scss';

.itinerary-list {
  max-width: var(--page-container-width, 1260px);
  margin: 40px auto 40px 100px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.day__date:first-child:before {
  content: '';
  height: 1px;
  border-top: 1px solid #e7e7e7;
  position: relative;
  width: 100%;
  display: block;
  z-index: 0;
}

.solution__day {
  position: relative;
  page-break-after: always;
  margin-bottom: 10px;
}

.day__label {
  margin: 0px;
  padding: 8px 0 0 0;

  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 118.14%;
  letter-spacing: -0.005em;
  color: rgba(7, 29, 59, 0.5);

  & > strong {
    color: #071d3b;
  }
}

.day__activities {
  position: relative;
}

.b-show-map {
  font-size: 16px;
  padding-right: 16px;
  position: relative;
  border: 0;
  appearance: none;
  background-color: transparent;
  color: #a3abb6;
  line-height: 30px;
  height: 26px;
  cursor: pointer;
}
.b-show-map::after {
  content: '';
  top: 0;
  right: 0;
  position: absolute;
  width: 16px;
  height: 100%;
  background-image: url("data:image/svg+xml,%3Csvg width='9' height='11' viewBox='0 0 9 11' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9 5.5L0.75 10.2631L0.75 0.73686L9 5.5Z' fill='%23A3ABB6'/%3E%3C/svg%3E%0A");
  background-size: 8px;
  background-position: center right;
  background-repeat: no-repeat;
  opacity: 0.5;
  transition: transform 0.2s linear;
  transform-origin: 75% center;
  will-change: transform;
}
.b-show-map.active::after {
  transform: rotate(60deg);
}

.icon {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  font-size: 100px;
  color: #a3abb6;
  display: flex;
  align-items: center;
  justify-content: center;
}

.core-button {
  --core-btn-bg-color: var(--btn-primary-color, hsl(208, 100%, 41%));
  --core-btn-border: var(--btn-primary-color, hsl(208, 100%, 41%));
  --core-btn-color: #fff;
  height: 40px;
  line-height: 41px;
  color: var(--core-btn-color);
  border-radius: 10px;
  padding: 0 20px;
  background-color: var(--core-btn-bg-color);
  border: 1px solid var(--core-btn-border);
  font-size: 16px;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
}

.core-button.outline {
  --core-btn-bg-color: #fff;
  --core-btn-border: var(--btn-primary-color, hsl(208, 100%, 41%));
  --core-btn-color: var(--btn-primary-color, hsl(208, 100%, 41%));
}

.radio-section {
  background: #071d3b;
  border-radius: 100px;
  padding: 10px;
}

.radio-section > * {
  margin: 10px;
}
</style>
